import { TAG_COLORS } from "../constants";

export default function TagBadge({ tag, style = {} }) {
  const c = TAG_COLORS[tag] || TAG_COLORS.Other;
  return (
    <span style={{
      padding: "2px 10px", backgroundColor: c.bg, color: c.color,
      border: `0.5px solid ${c.border}`, borderRadius: "20px",
      fontSize: "11px", fontWeight: "500", whiteSpace: "nowrap", ...style
    }}>{tag}</span>
  );
}